import React, { useState, useEffect, useRef } from 'react';
import {
  Box, Button, Card, Grid, Typography, IconButton, Dialog,
  DialogTitle, DialogContent, DialogActions, TextField
} from '@mui/material';
import { CloudUpload, Delete, ContentCopy } from '@mui/icons-material';
import { getMedia, uploadMedia, deleteMedia } from '../services/api';

function MediaPage() {
  const [media, setMedia] = useState([]);
  const [deleteDialog, setDeleteDialog] = useState({ open: false, item: null });
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef();

  useEffect(() => { loadMedia(); }, []);

  const loadMedia = async () => {
    try {
      const { data } = await getMedia();
      setMedia(data);
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const handleUpload = async (e) => {
    const files = e.target.files;
    if (!files.length) return;

    setUploading(true);
    try {
      for (const file of files) {
        const formData = new FormData();
        formData.append('file', file);
        await uploadMedia(formData);
      }
      loadMedia();
    } catch (error) {
      console.error('Erreur upload:', error);
    } finally {
      setUploading(false);
      fileInputRef.current.value = '';
    }
  };

  const handleDelete = async () => {
    try {
      await deleteMedia(deleteDialog.item._id);
      setDeleteDialog({ open: false, item: null });
      loadMedia();
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const copyUrl = (url) => {
    const fullUrl = `http://localhost:3011${url}`;
    navigator.clipboard.writeText(fullUrl);
  };

  const isImage = (mimeType) => mimeType?.startsWith('image/');

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4" fontWeight="bold">Medias</Typography>
        <Button
          variant="contained"
          startIcon={<CloudUpload />}
          onClick={() => fileInputRef.current.click()}
          disabled={uploading}
        >
          {uploading ? 'Upload...' : 'Ajouter'}
        </Button>
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleUpload}
          style={{ display: 'none' }}
          multiple
          accept="image/*,.pdf,.doc,.docx"
        />
      </Box>

      <Grid container spacing={2}>
        {media.map((item) => (
          <Grid item xs={6} sm={4} md={3} lg={2} key={item._id}>
            <Card sx={{ position: 'relative', '&:hover .actions': { opacity: 1 } }}>
              <Box
                sx={{
                  height: 150,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: '#F5F6F9',
                  overflow: 'hidden'
                }}
              >
                {isImage(item.mimeType) ? (
                  <img
                    src={`http://localhost:3011${item.url}`}
                    alt={item.alt || item.originalName}
                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                  />
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    {item.originalName?.split('.').pop()?.toUpperCase()}
                  </Typography>
                )}
              </Box>
              <Box
                className="actions"
                sx={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  opacity: 0,
                  transition: 'opacity 0.2s',
                  bgcolor: 'rgba(0,0,0,0.5)',
                  borderRadius: 1,
                  m: 0.5
                }}
              >
                <IconButton size="small" sx={{ color: 'white' }} onClick={() => copyUrl(item.url)}>
                  <ContentCopy fontSize="small" />
                </IconButton>
                <IconButton size="small" sx={{ color: 'white' }} onClick={() => setDeleteDialog({ open: true, item })}>
                  <Delete fontSize="small" />
                </IconButton>
              </Box>
              <Box p={1}>
                <Typography variant="caption" noWrap display="block">
                  {item.originalName}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {(item.size / 1024).toFixed(1)} KB
                </Typography>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Dialog open={deleteDialog.open} onClose={() => setDeleteDialog({ open: false, item: null })}>
        <DialogTitle>Supprimer le media</DialogTitle>
        <DialogContent>Supprimer "{deleteDialog.item?.originalName}" ?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialog({ open: false, item: null })}>Annuler</Button>
          <Button color="error" variant="contained" onClick={handleDelete}>Supprimer</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default MediaPage;
